import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';

import styles from './CustomError.module.scss';

const CustomError = (props: { error: string }) => {
  return (
    <div className={styles.customErrorOverlay}>
      <div className={styles.errorInfoContainer}>
        <div tabIndex={0}>
          <Trans
            i18nKey={props.error}
            components={{
              1: (
                <a
                  href="https://learn.cortico.ai/?contact=true"
                  target="_blank"
                />
              ),
            }}
          />
        </div>
        <Link to="/">
          <Button
            color="primary"
            size="sm"
            className={styles.okButton}
            role="button"
          >
            Ok
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default CustomError;
